import router from "@/router"
import store from "@/store/index"
import Vue from "vue"

export function renderLogin() {
	const path = window.location.pathname
	// Parallel failed requests must not replace the destination with the login page.
	if (path === "/signin") return
	if (path !== "/gauth") {
		sessionStorage.setItem("redirect", `${path}${window.location.search}${window.location.hash}`)
	}
	store.dispatch("resetLogin")
	router.replace({ name: "signin", query: { reason: "authentication_required" } })
}

export function restrictedPage() {
	Vue.toasted.show("You are not authorized to do that.", {
		type: "error",
		duration: 2000,
	})
	router.push({ name: "not-authorized" })
}

export function pageNotFound() {
	router.push({ name: "not-found" })
}

export function printErrorMessage(message) {
	Vue.toasted.show(message, {
		type: "error",
		duration: 2000,
	})
}

export function somethingWrong() {
	Vue.toasted.show("Something went wrong. Please retry.", {
		type: "error",
		duration: 2000,
	})
}
